module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Service"
  }, [_c('div', {
    staticClass: "Content"
  }, [_c('div', {
    staticClass: "describe"
  }, [_c('div', {
    staticClass: "describeContent"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.titleCont))])]), _vm._v(" "), (_vm.cancelState) ? _c('h4', {
    staticClass: "cancelBut",
    on: {
      "click": _vm.cancelOrderFn
    }
  }, [_vm._v("取消订单")]) : _vm._e()]), _vm._v(" "), _c('xk-waiter', {
    attrs: {
      "src": '../../../../assets/img/yonghu/touxiang.jpg',
      "name": _vm.DjOrderInfo ? _vm.DjOrderInfo.employ_name : '',
      "location": _vm.DjOrderInfo ? _vm.DjOrderInfo.book_address : '',
      "phone": _vm.DjOrderInfo ? _vm.DjOrderInfo.employ_phone : '',
      "headImg": _vm.DjOrderInfo ? _vm.DjOrderInfo.employ_head_path : ''
    }
  }), _vm._v(" "), _c('xk-Add', {
    attrs: {
      "time": _vm.DjOrderInfo ? _vm.DjOrderInfo.book_time : '',
      "origin": _vm.DjOrderInfo ? _vm.DjOrderInfo.book_address : '',
      "endPoint": _vm.DjOrderInfo ? _vm.DjOrderInfo.destination : ''
    }
  })], 1), _vm._v(" "), (_vm.reson.state) ? _c('xk-input-box', {
    attrs: {
      "title": "取消订单理由",
      "closeState": true
    },
    on: {
      "click": _vm.cancelOrderFn
    }
  }, [_c('div', {
    staticClass: "DjCancelOrder",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reson.val),
      expression: "reson.val"
    }],
    attrs: {
      "maxlength": "50",
      "placeholder": "请输入取消订单理由"
    },
    domProps: {
      "value": (_vm.reson.val)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reson, "val", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hintBox.stateShow) ? _c('xk-hint-box', {
    attrs: {
      "state": _vm.hintBox.state,
      "content": _vm.hintBox.content
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4bdc70c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/daijia/service.vue
// module id = 564
// module chunks = 0